window.shareProduct = function () {
    if (customElements.get('share-button')) return;

    class ShareButton extends HTMLElement {
        constructor() {
            super();

            this.elements = {
                shareButton: this.querySelector('.share-button__button'),
                successMessage: this.querySelector('[id^="ShareMessage"]'),
                urlInput: this.querySelector('input[data-base-url]'),
                content: this.querySelector('.share-button__fallback'),
                copyButton: this.querySelector('.button-copy'),
                closeButton: this.querySelector('.share-button__close')
            };

            if (!this.elements.shareButton || !this.elements.urlInput) return;

            this.elements.shareButton.addEventListener('click', this.toggleDetails.bind(this));
            this.elements.copyButton?.addEventListener('click', this.copyToClipboard.bind(this));
            this.elements.closeButton?.addEventListener('click', this.closeDetails.bind(this));
            document.querySelector('.background-overlay')?.addEventListener('click', this.closeDetails.bind(this));
            this.updateShareData();
        }

        getSelectedVariantId() {
            const currentUrl = new URL(window.location.href);
            const variantFromUrl = currentUrl.searchParams.get('variant');
            if (variantFromUrl) return variantFromUrl;

            const productScope = this.closest('.productView') || document;
            return productScope.querySelector('form[action*="/cart/add"] [name="id"]')?.value || '';
        }

        getShareUrl() {
            const baseValue = this.elements.urlInput.dataset.baseUrl || this.dataset.shareBaseUrl;

            try {
                const shareUrl = new URL(baseValue, window.location.origin);
                const variantId = this.getSelectedVariantId();

                shareUrl.search = '';
                shareUrl.hash = '';
                if (variantId) shareUrl.searchParams.set('variant', variantId);
                return shareUrl.toString();
            } catch (error) {
                return baseValue;
            }
        }

        getShareTitle() {
            return this.dataset.shareTitle || document.title;
        }

        buildShareHref(platform, url, title, image) {
            const encodedUrl = encodeURIComponent(url);
            const encodedTitle = encodeURIComponent(title);
            const encodedImage = encodeURIComponent(image || '');
            const links = {
                facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
                twitter: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
                pinterest: `https://pinterest.com/pin/create/button/?url=${encodedUrl}&media=${encodedImage}&description=${encodedTitle}`,
                tumblr: `https://www.tumblr.com/widgets/share/tool?canonicalUrl=${encodedUrl}`,
                telegram: `https://telegram.me/share/url?url=${encodedUrl}&text=${encodedTitle}`,
                email: `mailto:?subject=${encodedTitle}&body=${encodedUrl}`,
                whatsapp: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`
            };
            return links[platform] || url;
        }

        updateShareData() {
            const url = this.getShareUrl();
            const title = this.getShareTitle();
            const image = this.dataset.shareImage || '';

            this.elements.urlInput.value = url;
            this.elements.urlInput.dataset.url = url;
            this.querySelectorAll('[data-share-platform]').forEach((link) => {
                link.href = this.buildShareHref(link.dataset.sharePlatform, url, title, link.dataset.shareImage || image);
            });
            return { url, title };
        }

        async toggleDetails(event) {
            event.preventDefault();
            event.stopPropagation();

            const shareData = this.updateShareData();
            const useNativeShare = window.matchMedia('(max-width: 1024px)').matches && typeof navigator.share === 'function';

            if (useNativeShare) {
                try {
                    await navigator.share(shareData);
                    return;
                } catch (error) {
                    if (error?.name === 'AbortError') return;
                }
            }
            this.openDetails();
        }

        openDetails() {
            if (!this.elements.content) return;

            this.setProductInfoTop(this.getProductInfoPosition());
            this.elements.successMessage?.classList.add('hidden');
            this.elements.urlInput.classList.remove('is-copy');
            this.elements.content.classList.toggle('is-open');
            document.body.classList.add('modal-share-open');
        }

        async copyToClipboard(event) {
            event.preventDefault();
            event.stopPropagation();
            const { url } = this.updateShareData();

            try {
                if (navigator.clipboard?.writeText) {
                    await navigator.clipboard.writeText(url);
                } else {
                    this.elements.urlInput.focus();
                    this.elements.urlInput.select();
                    document.execCommand('copy');
                }

                this.elements.successMessage?.classList.remove('hidden');
                this.elements.successMessage?.setAttribute('aria-hidden', 'false');
                this.elements.urlInput.classList.add('is-copy');
                window.setTimeout(() => {
                    this.elements.successMessage?.classList.add('hidden');
                    this.elements.successMessage?.setAttribute('aria-hidden', 'true');
                }, 3000);
            } catch (error) {
                this.elements.urlInput.focus();
                this.elements.urlInput.select();
            }
        }

        closeDetails(event) {
            event?.preventDefault();
            this.updateShareData();
            this.elements.successMessage?.classList.add('hidden');
            this.elements.successMessage?.setAttribute('aria-hidden', 'true');
            this.elements.urlInput.classList.remove('is-copy');
            this.elements.content?.classList.remove('is-open');
            document.body.classList.remove('modal-share-open');
            this.setProductInfoTop(0);
        }

        getProductInfoPosition() {
            const stickyElement = document.querySelector('.productView-details');
            const parentElement = stickyElement?.parentNode;
            if (!stickyElement || !parentElement) return 0;

            const stickyRect = stickyElement.getBoundingClientRect();
            const parentRect = parentElement.getBoundingClientRect();
            return stickyRect.top - parentRect.top;
        }

        setProductInfoTop(top) {
            document.querySelector('.productView-details')?.style.setProperty('--sticky-top', `${top}px`);
        }
    }

    customElements.define('share-button', ShareButton);
};

const shareShow = document.body.classList.contains('quick-view-show');
const productShare = document.querySelectorAll('.halo-productView .productView-share').length;

if (document.body.classList.contains('template-product')) {
    if ((!shareShow && productShare) || (shareShow && productShare === 0)) window.shareProduct();
} else {
    window.shareProduct();
}
